export class Hash {
  constructor(public hash?: string) {
  }
}



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/model/reservation/hasher.model.ts